export default __webpack_public_path__ + "static/media/SEC1420.34I-32567_-17853_0.b567da14.jpg";